import * as React from 'react';

import { connect } from 'react-redux';

import AppState from '@webapp/store/state';

import { buildAuthorsCtrl } from '../../track/authors/index';
import SimpleArtist from '@common/types/artist/simple-artist';
import { ReleaseArtist } from '@common/types/release/release-artist';
import { COLLABORATOR_ROLES } from '@webapp/utils/release/constants';

import AnimatedHintCtrl from '@webapp/controllers/animated-hint';
import { Translate } from 'react-localize-redux';
import { ContactInfo } from '@webapp/types/common/contact-info';
import { ArtistSearchResult } from '@services/artist/types/artist-search-result';

interface ArtistSelectorCtrlProps {
  className?: string;
  activeArtist?: ReleaseArtist;
  artistList: SimpleArtist[];
  releaseArtists: ReleaseArtist[];
  releaseTitle: string;
  noRoleDropdown?: boolean;
  onRemoveArtist: (artists: ReleaseArtist[]) => void;
  onUpdateArtist: (artists: ArtistSearchResult) => void;
  handleEmailOrPhoneChange: (newContact: ContactInfo) => void;
  contact?: ContactInfo;
  showError: React.ReactNode;
  setShowError: React.Dispatch<React.SetStateAction<React.ReactNode>>;
  setRole: React.Dispatch<React.SetStateAction<string>>;
  setName?: React.Dispatch<React.SetStateAction<string>>;
  onConfirmName?: () => void;
}

const mapStateToProps = (state: AppState) => ({
  releaseTitle: state.release.release?.title || '',
});

const AuthorCtrl = buildAuthorsCtrl<ReleaseArtist, string>();

export const ArtistSelectorCtrl: React.FC<ArtistSelectorCtrlProps> = ({
  artistList,
  activeArtist,
  releaseArtists,
  onUpdateArtist,
  ...props
}) => {
  const [otherArtists] = React.useState(
    releaseArtists.filter((a) => a.id !== activeArtist?.id)
  );
  const handleOtherArtists = (value: ArtistSearchResult) => {
    onUpdateArtist(value);
  };

  const showHint = () => {
    return releaseArtists.length >= 4 ? (
      <AnimatedHintCtrl
        noBorderTop
        customTitle={
          <Translate id="RELEASE.ARTIST.ARTIST_SELECTOR.TIP.TITLE" />
        }
      >
        <Translate id="RELEASE.ARTIST.ARTIST_SELECTOR.TIP.TEXT" />
      </AnimatedHintCtrl>
    ) : null;
  };

  return (
    <AuthorCtrl
      id="contributors"
      className={props.className}
      label={<Translate id="RELEASE.ARTIST.TITLE" />}
      text={<Translate id="RELEASE.ARTIST.TEXT" />}
      roleList={COLLABORATOR_ROLES}
      defaultRole="main"
      artists={otherArtists}
      activeArtist={activeArtist}
      allArtists={releaseArtists}
      handleEmailOrPhoneChange={props.handleEmailOrPhoneChange}
      contact={props.contact}
      onNewAuthors={handleOtherArtists}
      showError={props.showError}
      setShowError={props.setShowError}
      setRole={props.setRole}
      setName={props.setName}
      disableDropdown={props.noRoleDropdown}
      noNumber
      songName={props.releaseTitle}
      type="collaborator"
      hint={showHint()}
      onConfirmName={props.onConfirmName}
    />
  );
};

export default connect(mapStateToProps)(ArtistSelectorCtrl);
